import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "col-md-12 container-fluid bg-white rounded shadow mt-3 p-3 text-start py-3" }
const _hoisted_3 = {
  key: 0,
  class: "text-start"
}
const _hoisted_4 = {
  key: 1,
  class: "text-start"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = { class: "col-sm-6 col-md-6 mb-3 mt-3" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "ประเภท", -1)
const _hoisted_9 = { class: "col-sm-12" }
const _hoisted_10 = { class: "form-check form-check-inline" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "inlineRadio1"
}, "บทความ", -1)
const _hoisted_12 = { class: "form-check form-check-inline" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "inlineRadio2"
}, "ข่าวสาร", -1)
const _hoisted_14 = {
  class: "accordion",
  id: "accordionPanelsStayOpenExample"
}
const _hoisted_15 = { class: "accordion-item" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "panelsStayOpen-headingOne"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#panelsStayOpen-collapseOne",
    "aria-expanded": "true",
    "aria-controls": "panelsStayOpen-collapseOne"
  }, "ภาษาไทย")
], -1)
const _hoisted_17 = {
  class: "accordion-collapse collapse show",
  id: "panelsStayOpen-collapseOne",
  "aria-labelledby": "panelsStayOpen-headingOne"
}
const _hoisted_18 = { class: "accordion-body" }
const _hoisted_19 = { class: "row text-start" }
const _hoisted_20 = { class: "col-sm-12 col-md-12 mb-3 mt-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "หัวข้อ", -1)
const _hoisted_22 = { class: "col-sm-12 col-md-12 mb-3 mt-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "คำอธิบาย", -1)
const _hoisted_24 = { class: "accordion-item" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "panelsStayOpen-headingTwo"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#panelsStayOpen-collapseTwo",
    "aria-expanded": "false",
    "aria-controls": "panelsStayOpen-collapseTwo"
  }, "ภาษาอังกฤษ")
], -1)
const _hoisted_26 = {
  class: "accordion-collapse collapse",
  id: "panelsStayOpen-collapseTwo",
  "aria-labelledby": "panelsStayOpen-headingTwo"
}
const _hoisted_27 = { class: "accordion-body" }
const _hoisted_28 = { class: "row text-start" }
const _hoisted_29 = { class: "col-sm-12 col-md-12 mb-3 mt-3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "หัวข้อ (ภาษาอังกฤษ)", -1)
const _hoisted_31 = { class: "col-sm-12 col-md-12 mb-3 mt-3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "คำอธิบาย (ภาษาอังกฤษ)", -1)
const _hoisted_33 = { class: "accordion-item" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "panelsStayOpen-headingThree"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#panelsStayOpen-collapseThree",
    "aria-expanded": "false",
    "aria-controls": "panelsStayOpen-collapseThree"
  }, "ภาษาจีน")
], -1)
const _hoisted_35 = {
  class: "accordion-collapse collapse",
  id: "panelsStayOpen-collapseThree",
  "aria-labelledby": "panelsStayOpen-headingThree"
}
const _hoisted_36 = { class: "accordion-body" }
const _hoisted_37 = { class: "row text-start" }
const _hoisted_38 = { class: "col-sm-12 col-md-12 mb-3 mt-3" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "หัวข้อ (ภาษาจีน)", -1)
const _hoisted_40 = { class: "col-sm-12 col-md-12 mb-3 mt-3" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "คำอธิบาย (ภาษาจีน)", -1)
const _hoisted_42 = { class: "col-sm-12 col-md-12 mb-3 mt-3" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "รูปภาพ", -1)
const _hoisted_44 = { class: "col-sm-12" }
const _hoisted_45 = { class: "col-sm-12 col-md-12 mb-3" }
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "d-flex mb-5 justify-content-center mt-3" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "ms-5" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JMUpload = _resolveComponent("JMUpload")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (this.$route.params.id == undefined)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_3, "เพิ่มบทความและข่าวสาร"))
        : (_openBlock(), _createElementBlock("h4", _hoisted_4, "แก้ไขบทความและข่าวสาร")),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                id: "inlineRadio1",
                type: "radio",
                name: "inlineRadioOptions",
                value: "บทความ",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.doc.type) = $event))
              }, null, 512), [
                [_vModelRadio, _ctx.doc.type]
              ]),
              _hoisted_11
            ]),
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                id: "inlineRadio2",
                type: "radio",
                name: "inlineRadioOptions",
                value: "ข่าวสาร",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.doc.type) = $event))
              }, null, 512), [
                [_vModelRadio, _ctx.doc.type]
              ]),
              _hoisted_13
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.doc.nameTH) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.doc.nameTH]
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    style: {"height":"5em"},
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.doc.descriptionTH) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.doc.descriptionTH]
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.doc.nameEN) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.doc.nameEN]
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    style: {"height":"5em"},
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.doc.descriptionEN) = $event))
                  }, "     ", 512), [
                    [_vModelText, _ctx.doc.descriptionEN]
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.doc.nameCH) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.doc.nameCH]
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    style: {"height":"5em"},
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.doc.descriptionCH) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.doc.descriptionCH]
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _createElementVNode("div", _hoisted_44, [
            _createVNode(_component_JMUpload, {
              folder: "media",
              modelValue: _ctx.doc.image,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.doc.image) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("img", {
              src: _ctx.imageUrl(_ctx.doc.image),
              height: "200"
            }, null, 8, _hoisted_46)
          ])
        ]),
        _createElementVNode("div", _hoisted_47, [
          _createVNode(_component_router_link, {
            class: "btn btn-dark",
            to: `/portal/blog`
          }, {
            default: _withCtx(() => [
              _createTextVNode("ยกเลิก")
            ]),
            _: 1
          }),
          _hoisted_48,
          _createElementVNode("a", {
            class: "btn btn-secondary bg-secondary",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)))
          }, "บันทึก")
        ])
      ])
    ])
  ]))
}